import React, { useState, useEffect } from "react";
import KnowYourProducts from "./KnowYourProducts";
import { useNavigate, useParams } from "react-router-dom";
import AvailabilityTasks from "../components/availabilityTasks/Index";
import ImageRecognization from "../components/ImageRecognization/Index";
import CustomStepper from "../components/stepperv1/Stepper";
import { AuthContext } from "../context/AuthContext";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

import DotCodeScaninng from "../components/dotcodeScaninng/DotCodeScaninng";
import Feedback from "../components/Feedback/Stepper";
import Competition from "../components/Competition/Index";
import WatchVideos from "../components/watchvideos/Stepper";
import DragDrop from "../components/CreateStick/Stepper";
import ClickLink from "../components/clickLink";

import AvaliabilityCustomStepper from "../components/educationStepperV2/Stepper";
import MonthlyTask from "./MonthlyTask";
import { getMonthlyDetail } from "../utils/apis";

import { translation_en } from "../translations/translation_en";
import { translation_hi } from "../translations/translation_hi";

const TasksDetails = (data: any) => {
  const { id } = useParams();
 
  const navigate = useNavigate();
  // --- local translation helper (same pattern as your old code) ---
 
  // If you want to force using the legacy local translations for type comparisons,
  // pick the language key stored in localStorage (fallback to en_IN).
 
     function translate(obj: any, path: string) {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  }
  
  // ✅ Choose translation based on saved language
  const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
  const translations = lang.startsWith("hi") ? translation_hi : translation_en;
  
  // ✅ Define t() function that mimics react-i18next’s syntax
  const t = (key: string) => translate(translations, key);
  // ----------------------------------------------------------------

  const [questData, setQuestData] = useState<any>(null);
  const [taskId, setTaskId] = useState<string | null>(null);
  const [monthlyData, setMonthlyData] = useState<any>(null);
  const [month, setMonth] = useState<string | undefined>(undefined);
  const [year, setYear] = useState<number | undefined>(undefined);

  const authContext = React.useContext(AuthContext);
  // prefer authContext.token, fallback to localStorage
const token =localStorage.getItem("token") || "";


  useEffect(() => {
    const fetchTaskData = async () => {
      const latitude = localStorage.getItem("latitude");
      const longitude = localStorage.getItem("longitude");
      const tokenn = localStorage.getItem("token");

      // keep using authContext token as before
      if (tokenn && id) {
      
        try {
          const languageHeader = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
          console.log("languageHeader", languageHeader)
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/task/fetch-task-details/${window.atob(id)}`,
            {
              method: "get",
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": languageHeader,
                Authorization: `Bearer ${tokenn}`,
                latitude: latitude ?? "",
                longitude: longitude ?? "",
              },
            }
          );

          if (!response.ok) {
            setQuestData(null);
            throw new Error("Network response was not ok");
          }

          const data = await response.json();

          window.parent.postMessage({ action: "changeLabel", label: data?.data?.task || "" }, "*");
          setQuestData(data);

          const fetchedTaskId = data.data?.task_id;
          if (fetchedTaskId) {
            setTaskId(fetchedTaskId);
          }
        } catch (error) {
          console.error("Failed to fetch task data:", error);
        }
      }
    };

    if (id && id !== null) fetchTaskData();
  }, [id, authContext, i18n.language]);

  useEffect(() => {
    // require questData first
    if (!questData?.data) return;
    
    const raw = questData?.data?.is_multiscan;
    const isMultiscan =
      raw === 1 || raw === "1" || raw === true || String(raw).toLowerCase() === "true";

    if (!isMultiscan) {
      console.log("Not a multiscan task, skipping monthly-detail call");
      return;
    }

    // get token same way other code does:
    const token = localStorage.getItem("token") || "";
    if (!token) {
      console.warn("Monthly detail: no auth token available (checked authContext + localStorage)");
      return;
    }

    // Ensure we have the task id
    const tId = questData?.data?.task_id ?? taskId;
    if (!tId) {
      console.warn("Monthly detail: no task id available yet");
      return;
    }

    // language same as you use elsewhere
    const language = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
    console.log("Langauge is : ", language)
    let mounted = true;
    (async () => {
      try {
         const monthArg = month && month.length ? month : undefined;
        const yearArg = typeof year === "number" ? year : undefined;
        console.log("-> Calling monthly detail API", { taskId: tId, language, month: monthArg, year: yearArg });
        // prefer your helper; it sets qs and headers properly
        const res = await getMonthlyDetail(token, tId, monthArg, yearArg, language);
        if (!mounted) return;
        console.log("monthly detail response:", res);

const localizedTitle = (language || "")
  .toString()
  .toLowerCase()
  .startsWith("hi")
  ? questData?.data?.task_title_hi
  : questData?.data?.task_title_en;

// keep original response shape, but attach a convenient `task_title` field
const enriched = res ? { ...res, task_title: localizedTitle } : { task_title: localizedTitle };

if (!res) {
  console.warn("getMonthlyDetail returned null — check network tab and backend logs");
}

setMonthlyData(enriched);

      } catch (err) {
        console.error("Failed to fetch monthly detail:", err);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [questData, taskId, authContext, month, year]);
 // Event listener for messages from iframe
     useEffect(() => {
       const handleMessage = (event: MessageEvent) => {
         console.log("event_coming here", event);
         if (event.data.type === "redirecttollp") {
           const encryptedTaskId = window.btoa(questData.data.task_id || questData.data.taskId );
           console.log(encryptedTaskId,'Taskkkkkid')
           navigate(`/tasks/${encryptedTaskId}`);
         }
       };
   
       // Add event listener
       window.addEventListener("message", handleMessage);
   
       // Cleanup listener on component unmount
       return () => window.removeEventListener("message", handleMessage);
     }, [navigate]);
  console.log("questData:", questData, id);
  console.log("questData:", questData?.data?.task_type, "===", t(`taskdetaitls.image_recogx.type`));
  console.log("taskId:", taskId);
  const TaskTypee = questData?.data?.task_type;

  return (
    <>
      {questData && (
        <>
          {TaskTypee === t(`taskdetaitls.educational.type`) ? (
            <CustomStepper questData={questData} />
          ) : TaskTypee === t(`taskdetaitls.feedback.type`) ? (
            <Feedback questData={questData} />
          ) : TaskTypee === t(`taskdetaitls.competition.type`) ? (
            <Competition questData={questData} />
          ) : TaskTypee === t(`taskdetaitls.dot_code_scanning.type`) ? (
            <>
              {console.log("raw is_multiscan from API wrapper:", questData?.data?.is_multiscan)}

              {(
                questData?.data?.is_multiscan === 1 ||
                questData?.data?.is_multiscan === "1" ||
                questData?.data?.is_multiscan === true ||
                String(questData?.data?.is_multiscan).toLowerCase() === "true"
              ) ? (
                <MonthlyTask
  questData={questData}
  monthlyData={monthlyData}
  token={token}
  taskId={questData?.data?.task_id ?? taskId}
  month={month}
  year={year}
  setMonth={setMonth}
  setYear={setYear}
  taskTitle={(localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN").startsWith("hi")? questData?.data?.task_title_hi: questData?.data?.task_title_en}
/>

              ) : (
                <DotCodeScaninng questData={questData} />
              )}
            </>
          ) : TaskTypee === t(`taskdetaitls.image_recogx.type`) ? (
            <ImageRecognization questData={questData} />
          ) : TaskTypee === t(`taskdetaitls.watch_videos.type`) ? (
            <WatchVideos questData={questData} />
          ) : TaskTypee === t(`taskdetaitls.buildstick.type`) ? (
            <DragDrop questData={questData} />
          ) : TaskTypee === t(`taskdetaitls.clicklink.type`) ? (
            <ClickLink questData={questData} />
          ) : (
          
             <div style={{ height: "100%" }}>
              {/* <div style={{ height: "calc(100vh - 254px)" }}> */}
              {/* <AvailabilityTasks questData={questData} /> */}
              {/* <SelfTask questData={questData}/> */}
              <AvaliabilityCustomStepper questData={questData} />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TasksDetails;